/** @format */

const TextDefaultProps = {
  tag: 'span',
  size: 'f7',
  
};

export default TextDefaultProps;
